import React, { useEffect } from 'react';
import { Typography, CircularProgress } from '@mui/material';
import { LOGIN_LOGIN } from '../../constants';
import '../../style/Login.css';

interface InitializingProps {
    setLoginPage: React.Dispatch<React.SetStateAction<string>>;
}

const Initializing: React.FC<InitializingProps> = ({ setLoginPage }) => {
    useEffect(() => {
        const timer = setTimeout(() => {
            setLoginPage(LOGIN_LOGIN);
        }, 2000);

        return () => clearTimeout(timer);
    }, [setLoginPage]);

    return (
        <>
            <Typography className='login_typography_title'>
                Initializing
            </Typography>

            <CircularProgress size={24} className='login_circular' />

            <Typography className='login_typography_content'>
                Please wait while we prepare IIoT Platform for use...
            </Typography>
        </>
    );
};

export default Initializing;
